const component = require('../component/component');

const avCols = Object.assign({}, component, {
    subelements: {
        options: [],
        selectAll: false,
        selectNone: false
    },
    sortName: '',
    sortable: false,

    init: function () {
        component.init.call(this);

        if (this.subelements.selectAll !== false) {
            this.subelements.selectAll.addEventListener('click', (e) => { e.preventDefault(); this.selectAll(); });
        }

        if (this.subelements.selectNone !== false) {
            this.subelements.selectNone.addEventListener('click', (e) => { e.preventDefault(); this.selectNone(); });
        }

        // .draggable / .draggable-handle: selectors for the third-party Shopify
        // Draggable library — intentionally un-prefixed (vendored _draggable.scss
        // styles them + the library emits sibling draggable-* classes we can't
        // rename). See scripts/behaviors.contract.md "Documented exception".
        this.sortable = new Draggable.Sortable(this.element, {
            draggable: ".draggable",
            handle: ".draggable .draggable-handle",
            mirror: {
                //appendTo: selector,
                appendTo: "body",
                constrainDimensions: true
            }
        });

        this.sortable.on("sortable:stop", (e) => {
            if (e.data.oldIndex < e.data.newIndex) {
                let movedOption = this.subelements.options[e.data.oldIndex];
                for (let i = e.data.oldIndex + 1; i <= e.data.newIndex; i++) {
                    this.subelements.options[i - 1] = this.subelements.options[i];
                }
                this.subelements.options[e.data.newIndex] = movedOption;
            } else if (e.data.oldIndex > e.data.newIndex) {
                let movedOption = this.subelements.options[e.data.oldIndex];
                for (let i = e.data.oldIndex; i >= e.data.newIndex + 1; i--) {
                    this.subelements.options[i] = this.subelements.options[i - 1];
                }
                this.subelements.options[e.data.newIndex] = movedOption;
            }
            //e.data.oldIndex
            //e.data.newIndex
            //e.data.dragEvent.data.source
        });
    },

    getValue: function () {
        if (this.isHidden && this.hiddenValue !== false) {
            return this.hiddenValue;
        }
        
        let value = [];

        this.subelements.options.forEach((avColCheckboxEl) => {
            if (avColCheckboxEl.checked) {
                value.push(avColCheckboxEl.value);
            }
        });

        return value;
    },

    selectAll: function () {
        this.subelements.options.forEach((avColCheckboxEl) => {
            avColCheckboxEl.checked = true;
        });
    },

    selectNone: function () {
        this.subelements.options.forEach((avColCheckboxEl) => {
            avColCheckboxEl.checked = false;
        });
    },

    formPostData: function (formPostData) {
        formPostData = component.formPostData.call(this, formPostData);

        let colsSort = [];

        this.subelements.options.forEach((avColCheckboxEl) => {
            colsSort.push(avColCheckboxEl.value);
        });

        formPostData[this.sortName] = colsSort;

        return formPostData;
    }
});


module.exports = avCols;